/**
 ************** DISCLAIMER ABOUT API USAGE IN MIGRATIONS *************
 * During the deployment of #1484 / v2.16.1, we used an API call here
 * to update the Categories list. It worked great in the browser, but
 * not so well in the iOS native apps. I'm not sure what happened, but
 * it might be a race condition between the app startup and the availability
 * of localStorage (and thus, the store itself) to feed into the API
 * calls. The end result was that the /categories call caused a 401, since
 * it had no credentials, and that crashed the migration, rendering the
 * state clean and throwing the user back in the login screen with a
 * "expired token" error.
 * To achieve similar results in the future, the best course of action
 * is to either simply cleanup the state you need to refresh (so the related
 * screen will simply reload it), or if it's a more complex matter, use
 * {@link migrateWithRequestUpdate} (from `state/Request`).
 *
 * For details, see https://ehungry-hq.slack.com/archives/CUF3C1W1Z/p1659655532844969?thread_ts=1657762044.748509&cid=CUF3C1W1Z
 */

/*
 * If you're looking for a way to revert a state version, check _store.js at config.version - there's a commented line there that will help you out.
 */

import { differenceInDays, parseISO, subDays } from 'date-fns'
import { migrateWithRequestUpdate } from 'state/Request'
import { newDate, PumpkinTimer } from 'utils'
import FMT from 'utils/fmt'

const migrations = {
	27: state => {
		const dates = state.orders.dates
		if (dates.end != FMT.dateISO(newDate(null))) { //this person is viewing a custom list, so let them be
			return state
		}

		//we will assume any user viewing an old date up to today is solely because of the never-ending Pumpkin Timer, and
		// thus we "fix" that to the new 3-day limit, so they stop listing ancient orders on their screens
		const diff = differenceInDays(parseISO(dates.end), parseISO(dates.start))
		if (diff >= PumpkinTimer.MAX_STREAK) {
			dates.start         = FMT.dateISO(subDays(newDate(null), PumpkinTimer.MAX_STREAK-1))
			dates.pumpkinStreak = PumpkinTimer.MAX_STREAK
		} else { //no need to change dates, but let's record the probable pumpkin streak
			dates.pumpkinStreak = diff
		}

		state.orders.dates = dates
		return state
	},
	28: migrateWithRequestUpdate(migrateWithRequestUpdate.SLICES.RESTAURANTS),
}
/**
 * Please, revisit the stats on Redux versions now and then, to clean up this list <3
https://order.ehungry.com/rcs/?form=manager_usage#redux_versions
 */

export default migrations
